import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtDate } from "@finance/lib/api";
import { Bell } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@finance/components/ui/popover";
import { Button } from "@finance/components/ui/button";

export default function NotificationsBell() {
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const load = useCallback(() => {
    api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
    api.get("/notifications/unread-count").then((r) => setCount(r.data.count)).catch(() => {});
  }, []);

  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);

  const openItem = async (n) => {
    if (!n.read) { await api.post(`/notifications/${n.id}/read`).catch(() => {}); }
    setOpen(false); load();
    if (n.link) navigate(n.link);
  };

  const markAll = async () => { await api.post("/notifications/read-all").catch(() => {}); load(); };

  return (
    <Popover open={open} onOpenChange={(v) => { setOpen(v); if (v) load(); }}>
      <PopoverTrigger asChild>
        <button className="relative flex w-full items-center gap-2 rounded-xl bg-white/[0.08] px-3 py-2 text-sm text-white transition-colors hover:bg-white/[0.14] dark:bg-white/[0.08] dark:hover:bg-white/[0.14]" data-testid="notifications-bell">
          <Bell size={16} /> Notifications
          {count > 0 && <span className="absolute right-2 top-1.5 rounded-full bg-[#1B4383] px-1.5 text-[10px] font-bold text-white" data-testid="notif-unread-count">{count}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="start" data-testid="notifications-panel">
        <div className="flex items-center justify-between border-b border-gray-100 px-3 py-2">
          <span className="lx-label">Notifications</span>
          {items.some((n) => !n.read) && <button className="text-xs text-[#122E5C] hover:underline" data-testid="notif-mark-all" onClick={markAll}>Mark all read</button>}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 && <div className="px-3 py-6 text-center text-sm text-gray-400">No notifications yet.</div>}
          {items.map((n) => (
            <button key={n.id} data-testid={`notif-${n.id}`} onClick={() => openItem(n)}
              className={`block w-full border-b border-gray-50 px-3 py-2 text-left hover:bg-gray-50 ${n.read ? "" : "bg-amber-50/40"}`}>
              <div className="flex items-center gap-2 text-sm font-medium text-gray-800">
                {!n.read && <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#1B4383]" />}{n.title}
              </div>
              <div className="mt-0.5 text-xs text-gray-500">{n.body}</div>
              <div className="mt-0.5 text-[10px] text-gray-400">{fmtDate(n.created_at)}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
